module.exports = __webpack_public_path__ + "c2e85f75c66a56220e8401088538ebf8.svg";